// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".indicadorRotas .collapsible-header {\n  background-color: #8e44ad;\n  font-weight: 700;\n}\n\n.indicadorRotas .collapsible-body {\n  width: 100%;\n}\n\n.indicadorRotas{\n  margin-bottom: 0px!important;\n}\n\n.linhaIndicadores{\n  flex-direction: row!important;\n  justify-content: space-around!important;\n}", ""]);
// Exports
module.exports = exports;
